import { render, staticRenderFns } from "./PublishWeChat.vue?vue&type=template&id=182edc52&scoped=true&"
import script from "./PublishWeChat.vue?vue&type=script&lang=js&"
export * from "./PublishWeChat.vue?vue&type=script&lang=js&"
import style0 from "./PublishWeChat.vue?vue&type=style&index=0&id=182edc52&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182edc52",
  null
  
)

export default component.exports